import React from "react";
import { cardWithItems } from "./Card";

const items = [
  {
    title: "ID",
    value: "id",
    full: true
  },
  {
    title: "Customer",
    value: "customer"
  },
  {
    title: "App",
    value: "appName"
  },
  {
    title: "Maximum licenses",
    value: "numLicenses"
  },
  {
    title: "Start",
    value: "start",
    date: true
  },
  {
    title: "End",
    value: "end",
    date: true
  },
  {
    title: "Trial",
    value: "isTrial"
  }
];

class LicenseCard extends React.Component {
  render = () => "";
}

export default cardWithItems(LicenseCard, items);



// WEBPACK FOOTER //
// ./src/library/card/LicenseCard.js